import React from "react";

function APlus() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3144 9.53195H18.75V10.9108H16.3144V13.3335H14.9356V10.9108H12.5V9.53195H14.9356V7.0835H16.3144V9.53195Z"
        fill="#383838"
      />
      <path
        d="M11.6815 14.1665H11.0788L7.78923 4.73942C7.68878 4.42692 7.38744 4.1665 7.03588 4.1665H5.85563C5.50407 4.1665 5.20273 4.42692 5.10229 4.73942L1.81267 14.1665H1.2351C1.00909 14.1665 0.833313 14.3748 0.833313 14.5832V15.4165C0.833313 15.6509 1.00909 15.8332 1.2351 15.8332H4.44938C4.65028 15.8332 4.85117 15.6509 4.85117 15.4165V14.5832C4.85117 14.3748 4.65028 14.1665 4.44938 14.1665H3.94715L4.52472 12.4998H8.3668L8.94436 14.1665H8.46724C8.24124 14.1665 8.06546 14.3748 8.06546 14.5832V15.4165C8.06546 15.6509 8.24124 15.8332 8.46724 15.8332H11.6815C11.8824 15.8332 12.0833 15.6509 12.0833 15.4165V14.5832C12.0833 14.3748 11.8824 14.1665 11.6815 14.1665ZM5.25296 10.4165L6.45831 7.05713L7.63856 10.4165H5.25296Z"
        fill="#383838"
      />
    </svg>
  );
}

export default APlus;
